/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxSize: NonNullable<unknown> }} Doc_Upload_Too_LargeInputs */

const en_doc_upload_too_large = /** @type {(inputs: Doc_Upload_Too_LargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`File exceeds the maximum size of ${i?.maxSize}.`)
};

const pt_br2_doc_upload_too_large = /** @type {(inputs: Doc_Upload_Too_LargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O arquivo excede o tamanho máximo de ${i?.maxSize}.`)
};

/**
* | output |
* | --- |
* | "File exceeds the maximum size of {maxSize}." |
*
* @param {Doc_Upload_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_upload_too_large = /** @type {((inputs: Doc_Upload_Too_LargeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Upload_Too_LargeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_upload_too_large(inputs)
	return pt_br2_doc_upload_too_large(inputs)
});